import * as Sentry from '@sentry/react';

Sentry.init({
	maxCacheItems: 20,
	maxBreadcrumbs: 50,
	environment: import.meta.env.VITE_ENV === 'PROD' ? 'production' : 'development',
	release: import.meta.env.VITE_APP_VERSION,
	dsn: import.meta.env.VITE_SENTRY_DSN,
	integrations: [Sentry.browserTracingIntegration()],
	tracePropagationTargets: [import.meta.env.VITE_API_URL],
	tracesSampleRate: 1.0,
});
